import { useLocation } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import ContactPromoLayout from '../components/ContactPageComponents/PagesComponents/ContactPromoLayout';
import NotFound404 from '../components/ErrorPageComponent/404';
import Clients from '../components/BrandSection/Clients';
import { useCachedFetch } from '../hooks/useCachedFetch';

const ContactPromoWrapper = ({ hideHeaderFooterSetter, hideLanguageSwitcherSetter }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const promoCode = query.get('promocode');

  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const { data: discountResponse, loading: discountLoading, error: discountError } = useCachedFetch('/data/locales/discount.json');
  
  const { data: promoResponse, loading: promoLoading, error: promoError } = useCachedFetch('/data/locales/promo.json');

  const allDiscountPromoCodes = useMemo(() => {
    const discountData = discountResponse?.DiscountData;
    if (!discountData?.offers) return [];
    
    return discountData.offers.flatMap(offer => 
      Object.values(offer.translations || {}).map(t => t.promocode)
    ).filter(Boolean);
  }, [discountResponse]);

  const allComingSoonPromoCodes = useMemo(() => {
    const comingSoonData = promoResponse?.comingSoonData;
    if (!comingSoonData) return [];
    
    return comingSoonData.flatMap(item => 
      Object.values(item.translations || {}).map(t => t.promoPageInfo?.mainPromocode)
    ).filter(Boolean);
  }, [promoResponse]);

  const isValidPromoCode = useMemo(() => {
    return promoCode && 
      (allDiscountPromoCodes.includes(promoCode) || allComingSoonPromoCodes.includes(promoCode));
  }, [promoCode, allDiscountPromoCodes, allComingSoonPromoCodes]);

  useEffect(() => {
    if (discountLoading || promoLoading) {
      setIsLoading(true);
      return;
    }
    
    if (discountError || promoError) {
      console.error('Error loading data:', discountError || promoError);
      setHasError(true);
      setIsLoading(false);
      return;
    }
    
    setIsLoading(false);
    setHasError(false);
  }, [discountLoading, promoLoading, discountError, promoError]);

  if (isLoading) {
    return null;
  }

  if (hasError || !isValidPromoCode) {
    return <NotFound404 hideHeaderFooterSetter={hideHeaderFooterSetter} />;
  }

  return (
    <>
      <ContactPromoLayout 
        promoCode={promoCode} 
        hideHeaderFooterSetter={hideHeaderFooterSetter} 
        hideLanguageSwitcherSetter={hideLanguageSwitcherSetter}
      />
      <Clients />
    </>
  );
};

export default ContactPromoWrapper;